import { formatWithOptions } from 'date-fns/esm/fp'
import { format, formatDistanceToNow, differenceInDays } from 'date-fns/esm'

import { ja, enUS } from 'date-fns/esm/locale'

const locales = { ja, enUS }

global.__localeId__ = 'ja'

export const fmtfp = function(formatStr = 'PP') {
  return formatWithOptions({ locale: locales[global.__localeId__] }, formatStr)
}

export const fmt = function(date, formatStr = 'PPpp') {
  return format(date, formatStr, {
    locale: locales[global.__localeId__]
  })
}

export const fmtToNow = function(date) {
  return formatDistanceToNow(date, {
    addSuffix: true,
    locale: locales[global.__localeId__]
  })
}

export const diffDays = differenceInDays
